import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app/app.component';
import { ExplorerSideBarComponent } from './components/explorer-side-bar/explorer-side-bar.component';
import { ExplorerViewComponent } from './components/explorer-view/explorer-view.component';
import { ExplorerFooterComponent } from './components/explorer-footer/explorer-footer.component';
import { ExplorerMainMenuComponent } from './components/explorer-main-menu/explorer-main-menu.component';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  declarations: [
    AppComponent,
    ExplorerSideBarComponent,
    ExplorerViewComponent,
    ExplorerFooterComponent,
    ExplorerMainMenuComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule
  ], providers: [
  ]
})
export class ExplorerModule { }
